import { START_TOUR, END_TOUR, CLOSE_TOUR_BUTTON_CLICKED, OPEN_END_TOUR_MODAL } from '../actions/toggleTourActions'

let initialState = {
  toggleOn: false,
  isCloseTourButtonClicked: false,
  endTourModal: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case START_TOUR:
      return { ...state, toggleOn: true }
    case END_TOUR:
      return { ...state, toggleOn: false}
    case CLOSE_TOUR_BUTTON_CLICKED:
      return { ...state, isCloseTourButtonClicked: true}
    case OPEN_END_TOUR_MODAL:
      return { ...state, endTourModal: true}
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/toggleTourReducer.js